
import AppViewEditor from "@/components/view-editor/ViewEditor.vue";
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { ViewService } from "@/services/view-service";
import Vue from "vue";

export default Vue.extend({
	data() {
		return{
			browse: null as Browse | null,
			view: new View()
		};
	},
	async created() {
		let browseID = parseInt(this.$route.params.browseId);
		let viewID = parseInt(this.$route.params.viewId || "0");
		this.browse = (await BrowseService.getBrowse(browseID)).browse;
		if (viewID != 0){
			this.view = await ViewService.getView(viewID);
			this.view.BrowseID = this.browse.ID;
			this.view.Table = this.browse.Table;
		}else{
			this.view = new View();
			this.view.BrowseID = browseID;
			this.view.UserID = parseInt(this.$route.params.userId);
			this.view.Table = this.browse.Table;
		}
	},
	components: {
		AppViewEditor
	}
});
